/**
 * This is used within a field or group to determine when to show that field or group.
 */
export type TFieldValue = string | number | boolean | undefined | null;

// oxlint-disable-next-line no-shadow
export enum IConditionComparisonOperationsEnum {
  "noteq" = "!=",
  "eq" = "==",
  "in" = "in",
  "notin" = "notin",
  "includes" = "includes",
  "excludes" = "excludes",
  "intersects" = "intersects",
  "XOR" = "XOR",
}

export type IConditionComparisonOperations =
  | IConditionComparisonOperationsEnum
  | "!="
  | "=="
  | "in"
  | "notin"
  | "excludes"
  | "includes"
  | "intersects"
  | "XOR";

// oxlint-disable-next-line no-shadow
export enum IConditionActionsEnum {
  "hidden" = "hidden",
  "disabled" = "disabled",
  "readonly" = "readonly",
  "visible" = "visible",
}
export type IConditionActions =
  | "hidden"
  | "disabled"
  | "readonly"
  | "visible"
  | IConditionActionsEnum;

export interface ICondition {
  value: TFieldValue | TFieldValue[];
  parameter: string;
  operation: IConditionComparisonOperations;
  action?: IConditionActions;

  /**
   * When the source is workflow the node guard has been automatically created by the workflow builder.
   * This _source lets change the editability / visibility of the guards in the FE
   */
  _source?: "workflow" | undefined;
}
